export default require("./node_modules/vue-grid-layout/dist/vue-grid-layout.common.js");